//
//
//
//
//
//
//
//
//
//
//
//

import axios from 'axios'

export default {
    data() {
            return {
                singleComment: null
            }
        },
        mounted() {
            console.log(this.$route.params.id * 1);
            var self = this;
            axios.get('http://localhost:8008/mod', {
                    params: {
                        id: this.$route.params.id * 1
                    }
                })
                .then(function(response) {
                    self.singleComment = response.data[0];
                    console.log(self.singleComment);
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        methods:{
        	showAlert(){
        		var self = this;
        		axios.get('http://localhost:8008/save', {
                    params: {
                    	id:self.singleComment.id,
                        title:self.singleComment.title,
                        subtitle:self.singleComment.subtitle,
                        rating:self.singleComment.rating,
                        content:self.singleComment.content
                    }
                })
                .then(function(response) {
                    self.singleComment = response.data[0];
                    console.log(self.singleComment);
                })
                .catch(function(error) {
                    console.log(error);
                });
                console.log(this.singleComment.content);
        		alert('保存成功')
        	}
        }
}



// WEBPACK FOOTER //
// ./src/views/mod.vue